/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Penalty details applied to a team
 * @export
 * @interface PenaltyRecord
 */
export interface PenaltyRecord {
    /**
     * 
     * @type {string}
     * @memberof PenaltyRecord
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof PenaltyRecord
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PenaltyRecord
     */
    reason?: string;
    /**
     * 
     * @type {number}
     * @memberof PenaltyRecord
     */
    appliedAt?: number;
    /**
     * Set when the penalty was applied in the context of a specific match.
     * @type {string}
     * @memberof PenaltyRecord
     */
    matchId?: string;
    /**
     * Admin user id that applied the penalty.
     * @type {string}
     * @memberof PenaltyRecord
     */
    appliedBy?: string;
}

/**
 * Check if a given object implements the PenaltyRecord interface.
 */
export function instanceOfPenaltyRecord(value: object): value is PenaltyRecord {
    return true;
}

export function PenaltyRecordFromJSON(json: any): PenaltyRecord {
    return PenaltyRecordFromJSONTyped(json, false);
}

export function PenaltyRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): PenaltyRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'appliedAt': json['appliedAt'] == null ? undefined : json['appliedAt'],
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'appliedBy': json['appliedBy'] == null ? undefined : json['appliedBy'],
    };
}

export function PenaltyRecordToJSON(json: any): PenaltyRecord {
    return PenaltyRecordToJSONTyped(json, false);
}

export function PenaltyRecordToJSONTyped(value?: PenaltyRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'amount': value['amount'],
        'reason': value['reason'],
        'appliedAt': value['appliedAt'],
        'matchId': value['matchId'],
        'appliedBy': value['appliedBy'],
    };
}

